import {
  border,
  BorderProps,
  compose,
  css,
  flexbox,
  FlexboxProps,
  grid,
  GridProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  space,
  SpaceProps,
  variant,
} from '@wrisk/styled-system'
import { PropsWithChildren } from 'react'
import styled from 'styled-components'

import { Form, FormProps, lgBumps, xxlBumps } from '../atoms'
import { withDefaultProps } from '../defaultProps'
import { transition, TransitionProps } from '../transition'

export type FormBuilderContainerProperty = 'default' | 'short'

export type FormBuilderContainerProps = FormProps &
  BorderProps &
  FlexboxProps &
  GridProps &
  LayoutProps &
  PositionProps &
  PropsWithChildren &
  SpaceProps &
  TransitionProps & {
    variant?: FormBuilderContainerProperty
  }

const defaultProps = withDefaultProps<FormBuilderContainerProps>({
  variant: 'default',
})

export const FormBuilderContainer = styled(Form).attrs(
  defaultProps,
)<FormBuilderContainerProps>(
  css({
    display: 'flex',
    flexDirection: 'column',
  }),
  variant({
    scale: 'FormContainer',
    variants: {
      default: {
        rowGap: xxlBumps,
      },
      short: {
        rowGap: lgBumps,
      },
    },
  }),
  compose(border, flexbox, grid, layout, position, space, transition),
)
